import { IBasketItem } from 'lib/basket/types';
import { useBasket } from 'lib/hooks/basket/use-basket';
import currency from 'currency.js';

interface Props {
  voucherItem: IBasketItem<'voucher'>;
}

export const VoucherBasketItem = ({ voucherItem }: Props) => {
  const [basket, modifyBasket] = useBasket();

  return (
    <article className='grid grid-cols-4 gap-4'>
      <img
        src={voucherItem.data.voucher.image}
        alt={`image for Voucher`}
        className='col-span-1'
      />
      <section className='col-span-3 grid grid-cols-2'>
        <header className='col-span-1 mt-auto text-left flex flex-col'>
          <h3 className='line-clamp-2 mt-auto text-base'>
            Voucher for {voucherItem.data.voucher.recipient}
          </h3>
          <span className='text-sm text-gray-600 italic'>
            Unit Price:{' '}
            {currency(voucherItem.data.price, {
              fromCents: true,
              symbol: '£',
            }).format()}
          </span>
          <span className='text-gray-600 italic text-sm'>Voucher</span>
        </header>
        <button
          className='col-span-1 ml-auto text-xs text-red-default hover:underline mb-auto'
          onClick={() =>
            modifyBasket({ type: 'remove', payload: voucherItem })
          }>
          remove
        </button>

        <div className='col-span-1 col-start-2'>
          <dl className='flex flex-col justify-end w-full h-full'>
            <dt className='ml-auto mt-auto'>Total:</dt>
            <dd className='font-bold lining-nums ml-auto '>
              {currency(voucherItem.data.price, {
                fromCents: true,
                symbol: '£',
              }).format()}
            </dd>
          </dl>
        </div>
      </section>
    </article>
  );
};
